import React, { useEffect, useState } from "react";
import {
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Dialog,
  Stack,
  Button,
  Typography,
} from "@mui/material";

const Cobrowser = (props) => {
  const {
    OpenDialog,
    handleClose,
    CobrosweData,
    CobrosweData2,
    externalChatData,
  } = props;
  const [UrlvalidationError, setUrlValidationError] = useState(false);
  const [cobrowswerinput, setCobrowserInput] = useState("");
  const [type, setType] = useState("");
  const [typeValue, settypeValue] = useState();

  useEffect(() => {
    if (type == "Email") {
      settypeValue(externalChatData.email);
    } else {
      settypeValue(externalChatData.phonenumber);
    }
  }, [type]);

  return (
    <Dialog
      open={OpenDialog}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle
        variant="subtitle2"
        sx={{
          fontSize: "16px",
          fontWeight: 600,
          boxShadow:
            "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
        }}
      >
        Request Co-Browser
      </DialogTitle>

      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
          <Stack
            className="mt-3"
            sx={{ display: "flex", justifyContent: "center" }}
            spacing={1}
          >
            {JSON.parse(localStorage.getItem("permission")).map((module) => {
              if (module.moduleName === "CHAT_INTERACTION") {
                const value = module.screen.find(
                  (item) =>
                    item.screenId === "COBROWSE_PURE" && item.read && item.write
                );

                if (value) {
                  return (
                    <>
                      <label htmlFor="Select" className="form-label">
                        Type
                      </label>
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        onChange={(e) => setType(e.target.value)}
                      >
                        <option value="">Select Type</option>
                        <option value="Email">Email</option>
                        <option value="Phone">Phone</option>
                      </select>

                      {type && (
                        <input
                          className="form-control fs-13"
                          value={typeValue}
                          onChange={(e) => {
                            settypeValue(e.target.value);
                          }}
                          style={{ height: "40px", width: "450px" }}
                        />
                      )}
                    </>
                  );
                }
              }
            })}

            <>
              <label for="formFile" className="form-label fs-13">
                Co-Browser
              </label>
              <input
                className="form-control fs-13"
                onChange={(e) => {
                  setCobrowserInput(e.target.value);
                }}
                placeholder="Ex: www.setUrl.com"
                style={{ height: "40px", width: "450px" }}
              />
              {UrlvalidationError && (
                <Typography
                  className="fs-10"
                  variant="body2"
                  sx={{ color: "red" }}
                >
                  Please enter a valid URL
                </Typography>
              )}
            </>
          </Stack>
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          sx={{ textTransform: "capitalize !important" }}
          variant="outlined"
          onClick={() => {
            handleClose();
          }}
          size="small"
          disableElevation
          color="error"
          autoFocus
        >
          Close
        </Button>
        <Button
          onClick={() => {
            if (!cobrowswerinput) {
              setUrlValidationError(true);
            } else {
              JSON.parse(localStorage.getItem("permission")).map((module) => {
                if (module.moduleName === "CHAT_INTERACTION") {
                  const value = module.screen.find(
                    (item) =>
                      item.screenId === "COBROWSE_PURE" &&
                      item.read &&
                      item.write
                  );

                  if (value) {
                    CobrosweData2(cobrowswerinput,type);
                  }
                }
              });

              JSON.parse(localStorage.getItem("permission")).map((module) => {
                if (module.moduleName === "CHAT_INTERACTION") {
                  const value = module.screen.find(
                    (item) =>
                      item.screenId === "COBROWSE" && item.read && item.write
                  );

                  if (value) {
                    CobrosweData(cobrowswerinput);
                  }
                }
              });
            }
          }}
          sx={{ textTransform: "capitalize !important" }}
          variant="contained"
          size="small"
          disableElevation
        >
          Yes request Co-Browser
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Cobrowser;
